// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/ReceivingLocation.yaml
// Generated: 2026-10-20T12:35:34.061Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateReceivingLocation, UpdateReceivingLocation, ReceivingLocation } from '@/types/core/ReceivingLocation';

/**
 * ReceivingLocation Service
 * CRUD operations for ReceivingLocation via the ABP API.
 */
export const receivingLocationService = new EntityService<ReceivingLocation, CreateReceivingLocation, UpdateReceivingLocation>(
  '/api/core/receivinglocation',
  'ReceivingLocation',
);
